"use strict";

// Shared client-side validators referenced by wizard "customJavascriptIsValid" scripts,
// e.g. window.WizardValidationHelper.validateAccessControlAllowOrigin(value).
// Registered on window so the validation functions the Wizard compiles from the FormModel can reach it.

function validateAccessControlAllowOrigin(value) {
	var entries = String(value).split(",").map((entry) => entry.trim()).filter((entry) => entry.length > 0);
	var originPattern = /^[a-z][a-z0-9+.-]*:\/\/[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*(:\d{1,5})?$/;
	return entries.every((entry) => {
		var origin = entry.toLowerCase();
		if (origin.indexOf("*") !== -1) {
			return false;
		}
		if (!/^[\x21-\x7e]+$/.test(origin)) {
			return false;
		}
		if (!originPattern.test(origin)) {
			return false;
		}
		var portMatch = origin.match(/:(\d{1,5})$/);
		if (portMatch === null) {
			return true;
		}
		var port = parseInt(portMatch[1], 10);
		return port >= 1 && port <= 65535;
	});
}

var WizardValidationHelper = {
	validateAccessControlAllowOrigin: validateAccessControlAllowOrigin
};

if (typeof window !== "undefined") {
	window.WizardValidationHelper = WizardValidationHelper;
}

module.exports = WizardValidationHelper;
